// The Meetings area's tabs (reset PR3). The 2026-10-08 sidebar decision folds "Live meeting"
// into Meetings: the sidebar has one Meetings entry, and inside it Calendar (DS 1g) and Live
// notes (FR-M5 / FR-X4) sit side by side. Meeting notes for a recording open from the library.
import { useNavigate } from "react-router-dom";
import { Tabs } from "@grackle/ui";
import { liveNotesPath, meetingsPath } from "./routes";

export type MeetingsTab = "calendar" | "live";

export default function MeetingsTabs({ slug, current }: { slug: string; current: MeetingsTab }) {
  const navigate = useNavigate();
  return (
    <Tabs
      className="meetings-tabs"
      value={current}
      onChange={(v) => navigate(v === "live" ? liveNotesPath(slug) : meetingsPath(slug))}
      items={[
        { value: "calendar", label: "Calendar" },
        { value: "live", label: "Live notes" },
      ]}
    />
  );
}
